import { useStyleConfig } from '@tectonic/elemason-components';
import clsx from 'clsx';
import { MediaAsset } from './Asset';

import type { Asset, ElemasonAssetListWidget } from '@tectonic/types';
import type { FC } from 'react';

type AssetListProps = {
  config: ElemasonAssetListWidget['config'];
  assets: Asset[];
};

const AssetList: FC<AssetListProps> = ({ config, assets }) => {
  const {
    list,
    asset: assetConfig,
    itemContainer: assetContConfig,
  } = config ?? {};
  const { style, className } = useStyleConfig(list ?? {});
  const { style: assetStyle, className: assetClassName } = useStyleConfig(
    assetConfig ?? {}
  );

  const { style: assetContStyle, className: assetContClassName } =
    useStyleConfig(assetContConfig ?? {});

  if (!assets) return null;

  return (
    <div
      style={style}
      className={clsx('flex w-full flex-row overflow-scroll', className)}
    >
      {assets.map((asset) => (
        <div
          style={assetContStyle}
          key={`asset-cont-${asset.damId}`}
          className={clsx('flex flex-col', assetContClassName)}
        >
          <MediaAsset
            asset={asset}
            key={asset.damId}
            style={assetStyle}
            config={assetConfig}
            className={assetClassName}
          />
        </div>
      ))}
    </div>
  );
};

export { AssetList };
